'use components';
import styled from "styled-components";
import {useState, useRef, useEffect} from "react";
import {useRouter} from "next/navigation";

const NeedSlideWrap = ({ slide }) => {
    const router = useRouter();
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const trackRef = useRef(null);
    const posRef = useRef(0);
    const reqRef = useRef(null);

    // 애니메이션 실행 함수
    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;

        const step = () => {
            posRef.current -= 0.5;
            track.style.transform = `translateX(${posRef.current}px)`;

            const trackWidth = track.scrollWidth / 2; // 슬라이드 원본 길이
            if (Math.abs(posRef.current) >= trackWidth) {
                posRef.current = 0; // 자연스럽게 리셋
            }
            reqRef.current = requestAnimationFrame(step);
        };

        if (hoveredIndex === null) {
            reqRef.current = requestAnimationFrame(step);
        }

        return () => cancelAnimationFrame(reqRef.current);
    }, [hoveredIndex]);

    return (
        <Slider>
            <Track
                ref={trackRef}
                className={hoveredIndex !== null ? "paused-wrap" : ""}
            >
                {[...slide, ...slide].map((item, idx) => (
                    <div
                        key={idx}
                        className={`need-slide-inner ${hoveredIndex === idx ? "paused-idx" : ""}`}
                        onMouseEnter={() => setHoveredIndex(idx)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className="image-wrap">
                            <img src={item.imageItem} alt={`slide-${idx}`} />
                        </div>
                        <div className="desc-wrap">
                            <p>{item.desc}</p>
                        </div>
                    </div>
                ))}
            </Track>
        </Slider>
    );
};

const Slider = styled.div`
    overflow: hidden;
    width: 100%;
`;

const Track = styled.div`
    display: flex;
    //width: max-content;
    gap: 30px;
    align-items: center;
    will-change: transform; /* 성능 최적화 */
    &.paused-wrap {
        .image-wrap {
            transition: .5s all ease-in-out;
            opacity: 0.25;
        }
        .need-slide-inner {
            &.paused-idx {
                .image-wrap {
                    opacity: 1;
                }
            }
        }
    }
    .need-slide-inner {
        cursor: pointer;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 40px;
        
        .image-wrap {
            width: 400px;
            height: 400px;
            transition: all .3s ease-in-out;
            box-shadow: 0 4px 16px -4px rgba(0, 0, 0, 0.2);
            border-radius: 20px;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        //&.paused-idx{
        //    .image-wrap {
        //        width: 450px;
        //        height: 450px;
        //    }
        //}
        .desc-wrap {
            width: 100%;
            p {
                font-weight: 600;
                font-size: 28px;
                text-align: center;
                letter-spacing: 0.02em;
                color: #FFFFFF;
            }
        }
    }
`;

export default NeedSlideWrap;
